import React, { useState, useEffect } from "react";
import { Button, Form, Layout, Spin, Table } from "antd"
import SideNavBar from "../../Components/SideBar/Sidebar"
import Navbar from "../../Components/Support/Header"
// import './StatutoryReporting.css'
import "../../GlobalCss/SPF/StatutoryReporting.css"
import Cookies from "js-cookie"
import axios from "axios"
import * as XLSX from "xlsx";
const { Header, Content } = Layout

const PaidBilled = () => {
    const jwtToken = Cookies.get("jwt_token")
    const userLogin = Cookies.get("UserLogin")
    const [form] = Form.useForm()
    const [PaidvsBilledData, getPaidvsBilledData] = useState([])
    const [tableLoader, setTableLoader] = useState(false)
    const [loaderDownload, setLoadDownload] = useState(false)

    useEffect(() => {
        GetPaidvsBilledData();
    }, [])

    const PaidBilledcolumns = [
        {
            title: 'File_No',
            dataIndex: 'File_Number',
            key: 'File_Number',
            width: 100,
            editable: true,
        },
        {
            title: 'Client Name',
            dataIndex: 'Client_Name',
            key: 'Client_Name',
            width: 100,
        },
        {
            title: 'RT Hrs',
            dataIndex: 'RT_Hrs',
            key: 'RT_Hrs',
            width: 150,
            editable: true,
        },
        {
            title: 'OT Hrs',
            dataIndex: 'OT_Hrs',
            key: 'OT_Hrs',
            width: 150,
            editable: true,
        },
        {
            title: 'DT Hrs',
            dataIndex: 'DT_Hrs_',
            key: 'DT_Hrs_',
            width: 150,
            editable: true,
        },
        {
            title: 'Status Paid',
            dataIndex: 'Status_Paid',
            key: 'Status_Paid',
            width: 150,
            editable: true,
        },
        {
            title: 'Download Date',
            dataIndex: 'DownloadDate',
            key: 'DownloadDate',
            width: 50,
            editable: true,
        },

    ]

    const GetPaidvsBilledData = async () => {
        try {
            let url = `${process.env.REACT_APP_BASE_URL}StatutoryReport/PaidDiscrepancyData`
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            setTableLoader(true)
            const response = await axios.get(url, config)
            if (response.data.statusCode == 200) {
                const res = response.data.payload
                const data = JSON.parse(res)
                console.log(data)
                getPaidvsBilledData(data)
                setTableLoader(false)
            }
            else {
                setTableLoader(false)
            }
        }
        catch (error) {
            setTableLoader(false)
            ErrorMessage("Error while fetching the data.")
        }
    }
    const handlePaidBilledList = () => {
        setLoadDownload(true)
        let sampleList = PaidvsBilledData;
        let loopedList = [];
        loopedList.length = 0;
        let len = sampleList.length;
        let i;
        for (i = 0; i < len; i++) {
            loopedList.push({
                File_No: sampleList[i].File_Number,
                ClientName: sampleList[i].Client_Name,
                RT_Hrs: sampleList[i].RT_Hrs,
                OT_Hrs: sampleList[i].OT_Hrs,
                DT_Hrs: sampleList[i].DT_Hrs_,
                StatusPaid: sampleList[i].Status_Paid,
                DownloadDate: sampleList[i].DownloadDate,
            });
        }
        setLoadDownload(false);
        handleOnPaidBilledExport(loopedList);
    }

    const handleOnPaidBilledExport = (props) => {
        const listData = props;
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(listData);
        XLSX.utils.book_append_sheet(wb, ws, "Myfile");
        XLSX.writeFile(wb, "PaidVSBilled.xlsx");
    }
    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                    <Header className="preview-header-class"><Navbar /></Header>
                    <Content className="preview-content">
                        <div className="reporting-title">Payroll Hours - Paid vs Billed</div>
                        <div className="statutory-table-div">
                            {
                                tableLoader ? <Spin tip="Loading...">
                                    <Form form={form} component={false}>
                                        <Table className="statutory-table" rowClassName="editable-row"
                                            bordered
                                            scroll={{ x: "max-content", y: 400 }}
                                            columns={PaidBilledcolumns}
                                            dataSource={PaidvsBilledData.map(item => ({ ...item, key: item.File_Number }))}
                                        />
                                    </Form>
                                </Spin> : PaidvsBilledData ?
                                    <Form form={form} component={false}>
                                        <Table className="statutory-table" rowClassName="editable-row"
                                            columns={PaidBilledcolumns}
                                            bordered
                                            dataSource={PaidvsBilledData.map(item => ({ ...item, key: item.File_Number }))}
                                            scroll={{ x: "max-content", y: 400 }}
                                        />
                                    </Form>
                                    : null
                            }
                        </div>
                        <div style={{ display: "flex", justifyContent: "end", width: "90%", marginLeft: "5.5%" }}>
                            <Button className="paidbilled-download-button" onClick={handlePaidBilledList} loading={loaderDownload}>Download Excel</Button>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default PaidBilled;